<inquiry>
  <div class="com-form">
    <form>
      <p class="ext">
        ご不明な点やお気づきの点などがございましたら、下記のフォームに必要事項を入力してお問合せください。
    なお、サービスの利用方法等を質問される場合は、まずは「<a href="/help">エディレコとは</a>」をご参照ください。
      </p>
      <div class="com-form__item ">
        <p class="com-form__item__caption"><span>お名前</span><i class="icon-require">必須</i></p>
        <div class="com-form__item__content">
          <div class="com-form__item__input input-text">
            <input type="text" name="name" is="edireco-binding" data="{data}" validate="string" placeholder="edireco太郎" errMsg="お名前を入力して下さい" required>
          </div>
        </div>
      </div>

      <div class="com-form__item">
        <p class="com-form__item__caption"><span>メールアドレス</span><i class="icon-require">必須</i></p>
        <div class="com-form__item__content">
          <div class="com-form__item__input input-text">
            <input type="text" name="email" is="edireco-binding" data="{data}" validate="string" placeholder="info@edireco.com" errMsg="メールアドレスを入力して下さい" required>
          </div>
        </div>
      </div>

      <div class="com-form__item">
        <p class="com-form__item__caption"><span>お問い合わせ内容</span><i class="icon-require">必須</i></p>
        <div class="com-form__item__content">
          <div class="com-form__item__input input-textarea">
            <textarea name="content" is="edireco-binding" data="{data}" validate="string" placeholder="お問い合わせ内容をご記入下さい" errMsg="お問い合わせ内容をご記入下さい" required></textarea>
          </div>
        </div>
      </div>


      <p class="footer_ext" style="font-weight: bold">
        フォームの内容を送信する際は、CROCO株式会社の「<a style="color:blue" href="https://cro-co.co.jp/privacypolicy/agreement/" target="_blank">個人情報の取扱</a>」をご確認いただき、同意をした上で「確認画面へ」のボタンを押してください
      </p>
        
      
      <div class="com-form__item__content">
        <div class="com-form__item__input input-checkbox">
          <input id="agreement_checkbox" type="checkbox" name="agree" is="edireco-binding" data="{data}" val="1" required errMsg="内容を確認して同意する場合はチェックを付けてください" />
          <label for="agreement_checkbox" style="font-weight: bold">個人情報の取扱に同意します</label>
        </div>
      </div>

      <div class="com-form__submit">
        <button type="button" class="com-btn-01" onclick="{confirmation}"><span>確認画面へ</span></button>
      </div>

    </form>
  </div>





  <script>
    import di from 'dependeny-injection'

    export default {
      data: di.inquiry.coreData,
      onMounted(){
        di.inquiry.lockUnload();
      },
      confirmation(e) {
        e.preventDefault();
        if (this.data.validate()) {
          di.inquiry.tag('confirm');
        }
      }
    }
  </script>
</inquiry>